<script lang="js">
import { Menu, Submenu, MenuItem } from 'element-ui'
import { h, toRef } from 'vue'
import MenuSearch from './menu-search.vue'
import { useActiveMenu } from '../hook/use-menu-list'

export default {
  components: {
    ElMenu: Menu,
    ElSubmenu: Submenu,
    ElMenuItem: MenuItem
  },
  props: {
    menuList: {
      type: Array,
      default: null,
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {slots}) {
    const renderMenuItem = (lists, depth = 1) => {
      return lists.map(list => {
        if(list.children?.length > 0) {
          return h('el-submenu', {
            props: {index: list.id, popperClass: 'pg-layout-menu__top-menu'},
            key: list.id,
          }, [
            ...renderMenuItem(list.children, depth + 1),
            h('div',{slot: 'title', style: {marginLeft: `${-10 * depth}px`}}, [
              h('i', {class: `${~list.icon?.indexOf('ivu-icon-') ? '' : 'ivu-icon-'}${list.icon ?? ''}`}),
              h('span', list.title)
            ])
          ])
        }else {
          return h('el-menuItem', {
            style: {paddingLeft: `${10 * depth}px`},
            props: {index: list.id},
            key: list.id
          }, [
            list.icon && depth === 1 ? h('i', {class: `el-menu-item-icon- ${~list.icon?.indexOf('ivu-icon-') ? '' : 'ivu-icon-'}${list.icon ?? ''}`}) : null,
            h('span', list.title)
          ])
        }
      })
    }

    const { activeMenu, selectMenu } = useActiveMenu(toRef(props, 'menuList'))
    const renderMenu = () => {
      return h('el-menu', {
        class: 'pg-layout-menu__top-menu',
        props: {
          uniqueOpened: true,
          defaultActive: activeMenu.value,
          collapseTransition: false,
          collapse: props.collapse
        },
        on: {
          select: selectMenu
        }}, renderMenuItem(props.menuList))
    }
    return () => h('div', { class: `pg-layout-menu ${props.collapse ? 'pg-layout-menu--collapse' : ''}` }, [
      slots.default?.(),
      h('div', { class: 'pg-layout-menu__top'}, [renderMenu()]),
      h(MenuSearch, { class: 'pg-layout-menu__bottom', on: {'on-select': selectMenu}})
    ])
  }
}
</script>
<style lang="scss">
@import '../style/layout-menu.scss';
</style>
